import * as React from 'react';
import classnames from 'classnames';
const ImageOverlay = ({ topLeft, topRight, bottomLeft, bottomRight, className, children }) => {
    return (<div className={classnames('image-overlay', className)}>
            {children}
            {topLeft && <div className="image-overlay__place image-overlay__place--top-left">{topLeft}</div>}
            {topRight && <div className="image-overlay__place image-overlay__place--top-right">{topRight}</div>}
            {bottomLeft && <div className="image-overlay__place image-overlay__place--bottom-left">{bottomLeft}</div>}
            {bottomRight && (<div className="image-overlay__place image-overlay__place--bottom-right">{bottomRight}</div>)}
        </div>);
};
export default ImageOverlay;
